import { Pipe } from '@angular/core';
var ShufflePipe = (function () {
    function ShufflePipe() {
    }
    // Using a version of the Fisher-Yates shuffle algorithm
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
    // Using a version of the Fisher-Yates shuffle algorithm
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
    ShufflePipe.prototype.transform = 
    // Using a version of the Fisher-Yates shuffle algorithm
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
    function (input) {
        if (!Array.isArray(input)) {
            return input;
        }
        var shuffled = input.slice();
        var n = input.length - 1;
        for (var i = 0; i < n; ++i) {
            var j = Math.floor(Math.random() * (n - i + 1)) + i;
            _a = [shuffled[j], shuffled[i]], shuffled[i] = _a[0], shuffled[j] = _a[1];
        }
        return shuffled;
        var _a;
    };
    ShufflePipe.decorators = [
        { type: Pipe, args: [{ name: 'shuffle' },] },
    ];
    /** @nocollapse */
    ShufflePipe.ctorParameters = function () { return []; };
    return ShufflePipe;
}());
export { ShufflePipe };
//# sourceMappingURL=shuffle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/shuffle.js
// module id = 232
// module chunks = 4